import { TasasFinancieras } from '../sections/TasasFinancieras/TasasFinancieras';
import { useAdminToast } from '../shell/AdminToastContext';

export const TasasFinancierasPage = () => {
    const toast = useAdminToast();
    return <TasasFinancieras toast={toast} />;
};

export default TasasFinancierasPage;
